<template>
  <div>
    <Table :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="overName_staffNo">
        <div class="name-status">
          <div class="user-box">
            <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }" v-if="row.salesmanName"></i>
            <span class="user-name">{{ row.owerStaffNo }}</span>
            <span v-if="row.owerStaffNo">/</span>
            <span class="user-name">{{ row.salesmanName }}</span>
          </div>
        </div>
      </template>

      <template slot-scope="{ row }" slot="calFactor">
        <span v-if="activityDetailData.rewardType == 3">-</span>
        <span v-else>{{ row.calFactor | calFactorText }}</span>
      </template>

      <template slot-scope="{ row }" slot="actCommission">
        <span v-if="activityDetailData.conditionalIndicator != 6 || activityDetailData.rewardType == 3">-</span>
        <span v-else>{{ row.actCommission ? row.actCommission : 0 }}%</span>
      </template>

      <template slot-scope="{ row }" slot="activityIncome">
        <span v-if="activityDetailData.conditionalIndicator != 6">-</span>
        <span v-else>{{ row.activityIncome }}</span>
      </template>
    </Table>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getListData" style="text-align: center; margin-top: 20px" />
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common, pageTool } from '@/api/mixins';

export default {
  props: ['actId', 'productType'],
  mixins: [common, pageTool],
  filters: {
    // 计算因子
    calFactorText(val) {
      switch (val) {
        case 1:
          return '业务员标保';
        case 2:
          return '业务员规保';
        case 3:
          return '业务员费用';
        default:
          return '-';
      }
    }
  },
  data() {
    return {
      activityDetailData: {},
      columns: [],
      tableData: []
    };
  },
  async created() {
    await this.getActivityDetail();
    // 个险
    if (this.productType == '1') {
      this.columns = [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '费用归属/业务员',
          align: 'center',
          minWidth: 250,
          slot: 'overName_staffNo'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'additionName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let receiptStatus = params.row.receiptStatus;
            switch (receiptStatus) {
              case '-1':
                return <span>无需回执</span>;
              case '0':
                return <span>待回执</span>;
              case '1':
                return <span>回执成功</span>;
              case '2':
                return <span>回执失败</span>;
              default:
                return <span>-</span>;
            }
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let verifyStatus = params.row.verifyStatus;
            switch (verifyStatus) {
              case '0':
                return <span>等待回访</span>;
              case '1':
                return <span>回访成功</span>;
              case '2':
                return <span>回访失败</span>;
              case '3':
                return <span>无需回访</span>;
              default:
                return <span>-</span>;
            }
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{hesitateDate ? filter.filterTime(hesitateDate, 'YYYY-MM-DD') : '-'}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '交费期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 120
        },
        {
          title: '业务员基础费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 140
        },
        {
          title: '计算因子',
          align: 'center',
          minWidth: 130,
          slot: 'calFactor'
        },
        {
          title: '奖励费率',
          align: 'center',
          minWidth: 130,
          slot: 'actCommission'
        },
        {
          title: '奖励',
          align: 'center',
          minWidth: 100,
          slot: 'activityIncome'
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 100
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 130
        }
      ];
    } else {
      this.columns = [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left',
          tree: true
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '费用归属/业务员',
          align: 'center',
          minWidth: 250,
          slot: 'overName_staffNo'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'additionName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 120
        },
        {
          title: '业务员基础费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 140
        },
        {
          title: '计算因子',
          align: 'center',
          minWidth: 130,
          slot: 'calFactor'
        },
        {
          title: '奖励费率',
          align: 'center',
          minWidth: 130,
          slot: 'actCommission'
        },
        {
          title: '奖励',
          align: 'center',
          minWidth: 100,
          slot: 'activityIncome'
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 100
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ];
    }
    this.getListData();
  },
  methods: {
    // 获取活动详情
    getActivityDetail() {
      return this.$http({
        url: '/buz/merchantActivity/detail',
        type: 'GET',
        data: {
          id: this.actId
        }
      }).then(res => {
        this.activityDetailData = res.data;
      });
    },

    getListData() {
      let data = {
        reportId: this.$route.query.reportId,
        type: 12,
        activityId: this.actId,
        userId: this.$route.query.userId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      this.$http({
        url: '/buz/userSalaryDetails/getDetail',
        type: 'POST',
        data
      }).then(res => {
        this.tableData = res.data;
        this.total = res.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
